import { Map } from "immutable";
import { CHANGE_FAVORITE_AMOUNT } from "../actions/favoriteAmounts";
import { CONFIG } from "../config";
var initialState = new Map(CONFIG.favoriteAmounts);
export default function displayModeReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CHANGE_FAVORITE_AMOUNT:
            return state.update(action.data.target, function () { return +action.data.amount; });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/favouriteAmountsReducer.js